
import Shortcode from "src/libs/useful/shortcode"
import { __, sprintf } from "src/libs/utilities"
import { IState, useMainStore } from "src/settings/zustand"
import { isAnonym, } from "src/settings/zustand/user"
import { IPETest } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store" 
import ExternalFinish from "./ExternalFinish"

/* Protopia Ecosystem component */
export interface IAnonymUserStartLabelProps {
   item: IPETest
}
const AnonymUserStartLabel = (props: IAnonymUserStartLabelProps): JSX.Element => { 
    const anonymUser = useMainStore((state: IState) => state.getAnonymUser() )
    const lastResults = useTestsStore((state: ITestsStore) => state.lastResults )

    const res = lastResults.find( (result: any) => result.testId === props.item.id )
    return isAnonym()
        ?
        <div className='small-container flex-centered flex-column py-3 px-5 mt-3 alert alert-danger' data-testid="anonym-user-start-label">
            <Shortcode content={ sprintf( __("Hallo, %s. "), anonymUser.display_name ) } />
            {
                !!res &&
                <div className="letter-spacing-1 small mt-4 text-center " data-testid="you-already-passed">
                    <div>
                        {__("You have already passed this test.")}
                    </div>
                    <ExternalFinish item={props.item} results={res.results} />
                </div>
            }
        </div>
        :
        <></>
}
export default AnonymUserStartLabel